// extracted by mini-css-extract-plugin
export default {"Container":"ComposeMail_Container__ethRz"};